export default "__VITE_ASSET__CaYoaj3z__"